export const isNeedDropdown = (target) => {
    if (!target || !(target instanceof HTMLElement)) {
        return false;
    }

    return target.scrollWidth > target.clientWidth || target.scrollHeight > target.clientHeight;
};

export const resetVisibility = (target, callback = null) => {
    if (!target) {
        return;
    }

    for (let i = 0; i < target.children.length; i++) {
        const child = target.children[i];
        child.removeAttribute('hidden');

        if (callback !== null && typeof callback === 'function') {
            callback(child);
        }
    }
};

export const hideAndGetOverflowItems = (target, params = {}, callback = null) => {
    if (!target) {
        return null;
    }

    Object.assign(
        {
            cloneItems: true,
        },
        params
    );

    if (!isNeedDropdown(target)) {
        return null;
    }

    let needHide = true;
    let prevNeedHide = true;
    const hideItems = [];

    for (let index = target.children.length - 1; index >= 0; index--) {
        const node = target.children[index];

        if (node.hasAttribute('data-skip-hide')) {
            continue;
        }

        const cloneNode = params.cloneItems ? node.cloneNode(true) : null;

        if (callback !== null && typeof callback === 'function') {
            callback({
                node,
                cloneNode,
                needHide,
                prevNeedHide,
            });
        }

        cloneNode?.setAttribute('hidden', '');
        hideItems.unshift(params.cloneItems ? cloneNode : node);

        if (needHide) {
            node.setAttribute('hidden', '');
            cloneNode?.removeAttribute('hidden');
        }

        prevNeedHide = needHide;
        if (!isNeedDropdown(target)) {
            needHide = false;
        }
    }

    return hideItems;
};
